<div *ngIf="commonSegmentFilters">
    <app-add-segment-popup-filter-row
        [template]="commonSegmentFilters"
        [dynamicFilters]="commonSegmentFilters.dynamicFilters"
        [isRecurring]="true"
    >
    </app-add-segment-popup-filter-row>
</div>

<div>
    <app-add-segment-popup-filter-row
        #segmentRecurringFilterSet
        [template]="recurringFilters"
        [dynamicFilters]="recurringFilters.dynamicFilters"
        [isRecurring]="true"
    >
    </app-add-segment-popup-filter-row>
</div>
<div class="level is-full-width button-row button-container">
    <div class="level-left">
        <app-filter-input
            *ngIf="!this.rowData?.isPolitical"
            [property]="this.addToPolitical"
        ></app-filter-input>
        <app-filter-input
            *ngIf="!this.rowData?.isDynamic"
            [property]="this.addToDynamic"
        ></app-filter-input>
    </div>
    <div class="level-right">
        <app-button
            (buttonClick)="close()"
            [buttonText]="'Cancel'"
            [type]="'stroked'"
        />
        <app-button
            (buttonClick)="save()"
            [buttonText]="'Save'"
            [type]="'flat'"
        />
    </div>
</div>
